import { a as _objectSpread2, e as colors, s as sizes, f as typography } from './transitions-f3664454.esm.js';
import { borderWidths, borders, breakpoints, motion, radii, shadows } from '@hover/blueprint-theme';
import { s as space } from './space-bf1de902.esm.js';
import _max from 'ramda/src/max';
import _reduce from 'ramda/src/reduce';
import { theme } from '@chakra-ui/react';
import { isNumber } from '@hover/utilities';
import 'polished';

// Get the highest z-index from Chakra
var highest = /*#__PURE__*/_reduce(_max, 0, /*#__PURE__*/Object.values(theme.zIndices).filter(isNumber));
var zIndices = {
  loading: highest + 100
};

/**
 * Combined foundations object for use in `extendTheme`
 *
 * @example
 * import { extendTheme } from '@chakra-ui/react';
 * import { foundations } from '.';
 *
 * ```ts
 * const theme = extendTheme({ ...foundations });
 * ```
 */
var foundations = /*#__PURE__*/_objectSpread2({
  borderWidths: borderWidths,
  borders: borders,
  breakpoints: breakpoints,
  colors: colors,
  motion: motion,
  radii: radii,
  shadows: shadows,
  sizes: sizes,
  space: space,
  zIndices: zIndices
}, typography);

export { foundations as f, zIndices as z };
